import axios from 'src/store/vue-axios/axios.js'

export default class SduiPlus {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // SDUI-PLUS -> /sdui-plus/*
  static sduiPlusUrl = () => '/sdui-plus'

  // SDUI-PLUS -> /sdui-plus/${id}*
  static sduiPlusByIdUrl = (id) => `/sdui-plus/${id}`

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // SDUI-PLUS -> /sdui-plus/${id}*
  static async getSduiPlusById (id) {
    return axios.get(this.sduiPlusByIdUrl(id))
  }
}
